"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TexasConfigCapability = void 0;
/**
 * Whether a persisted compositor config underwrites a Texas property; `unknown` means it could not be read.
 *
 * A caller MUST grant an exception only on `capable` — reading it as "not `notCapable`" silently extends
 * that exception to every config that failed to load.
 */
var TexasConfigCapability;
(function (TexasConfigCapability) {
    TexasConfigCapability["capable"] = "capable";
    TexasConfigCapability["notCapable"] = "notCapable";
    TexasConfigCapability["unknown"] = "unknown";
})(TexasConfigCapability || (exports.TexasConfigCapability = TexasConfigCapability = {}));
